/*
declare all the constants for Footer.js
*/
export const TEVALUE = "Technical Evaluation";
export const ONE = "1";
export const TOOLTIPLABELS = ['Send to PLASMA', 'Redo'];